import { config } from '@/config';

export const isValidUrl = (url: string): boolean => {
  return typeof url === 'string' && config.regex.url.test(url);
};
